import { isNative } from './device.js';

/**
 * Status bar text colour, per screen.
 *
 * The WebView runs edge to edge, so the status bar sits on whatever the page
 * draws there: the light surface on most screens, the camera preview on
 * capture and the live session. Set explicitly, never `Default` — that follows
 * the phone's dark mode and would put white text on the app's white surface.
 */
export type StatusBarBackdrop = 'light' | 'camera';

export async function setStatusBarBackdrop(backdrop: StatusBarBackdrop): Promise<void> {
  if (!isNative()) return;
  try {
    const { SystemBars, SystemBarsStyle } = await import('@capacitor/core');
    await SystemBars.setStyle({
      style: backdrop === 'camera' ? SystemBarsStyle.Dark : SystemBarsStyle.Light,
    });
  } catch {
    // Cosmetic; never block a screen on it.
  }
}
